export enum DateType {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}
